export default "__VITE_PUBLIC_ASSET__31b8c187__"